import {TradingIdeasService} from "./service/TradingIdeasService";
import {tradingIdeasDesktop, TradingIdeasDesktop} from "./desktop/TradingIdeasDesktopComponent";
import {tradingIdeasMobile, TradingIdeasMobile} from "./mobile/TradingIdeasMobileComponent";

import Elements from "./elements";

const rootDir = "app/trading-ideas";

export default angular.module("tfApp.trading-ideas", [Elements(rootDir)])
                      .service(TradingIdeasService.id, TradingIdeasService)
                      .component(TradingIdeasDesktop, tradingIdeasDesktop(rootDir))
                      .component(TradingIdeasMobile, tradingIdeasMobile(rootDir))
                      .name;
